import Link from "next/link";
import React, { ReactElement } from "react";
import { getCmsIcon } from "@kunduz/utility-common";
import { trackEvent } from "@kunduz/utility-analytics";
import classNames from "classnames";
import styles from "./dynamicHeroCtaButtons.module.scss";

export const HeroCtaButton = (props: Props): ReactElement => {
  const gradientToUse = {
    student: styles.blueG,
    teacher: styles.greenG,
    school: styles.blueG,
    parent: styles.blueG,
  };

  const primaryButtonColorToUse: Record<string, string> = {
    student: styles.bluePrimary,
    teacher: styles.greenPrimary,
    school: styles.bluePrimary,
    parent: styles.bluePrimary,
  };

  const ButtonIcon = getCmsIcon(props.icon);

  function handleClicked(label?: string) {
    trackEvent("Hero Component CTA Button Clicked", {
      label,
    });
  }

  switch (props.type) {
    case "primary":
      return (
        <Link
          href={props.url}
          className={classNames(primaryButtonColorToUse[props.profile])}
          target={props.target || "_self"}
          onClick={() => handleClicked(props.label)}
          shallow={props.shallow}
        >
          {props.icon && <ButtonIcon viewBox="0 0 24 24" />}
          {props.label}
        </Link>
      );
    case "secondary":
      return (
        <Link
          href={props.url}
          className={styles.secondary}
          target={props.target || "_self"}
          onClick={() => handleClicked(props.label)}
          shallow={props.shallow}
        >
          {props.icon && <ButtonIcon viewBox="0 0 24 24" />}
          {props.label}
        </Link>
      );
    case "tertiary":
      return (
        <Link
          href={props.url}
          className={styles.tertiary}
          target={props.target || "_self"}
          onClick={() => handleClicked(props.label)}
        >
          {props.icon && <ButtonIcon viewBox="0 0 24 24" />}
          {props.label}
        </Link>
      );
    case "link":
      return (
        <Link
          href={props.url}
          className={styles.link}
          target={props.target || "_self"}
          onClick={() => handleClicked(props.label)}
        >
          {props.icon && <ButtonIcon viewBox="0 0 24 24" />}
          {props.label}
        </Link>
      );
    case "gradient":
      return (
        <Link
          href={props.url}
          className={classNames(styles.tertiary, {
            [styles.blueG]: gradientToUse[props.profile],
          })}
          target={props.target || "_self"}
        >
          {props.icon && <ButtonIcon viewBox="0 0 24 24" />}
          {props.label}
        </Link>
      );
    default:
      break;
  }

  return <div></div>;
};

interface Props {
  label: string;
  url: string;
  icon?: string;
  target?: any;
  type?: any;
  profile: "student" | "teacher" | "school" | "parent";
  shallow?: boolean;
}
